import React, { useEffect } from "react";

import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./app/page";
import LandingPage from "./app/landing-page/page";
import ThankYouPage from "./app/thank-you/page";
import NotFound from "./app/not-found";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
